var _excluded = ["name", "size", "fixedWidth", "ariaLabel", "color", "svgProps"],
  _excluded2 = ["activeName", "inactiveName", "isActive", "size", "fixedWidth", "ariaLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import styled, { css } from 'styled-components';
import iconViewBoxes from "../IconViewBoxes";
import Box from "../Box";
import PartnerLogo, { PartnerNames } from "../PartnerLogo";
import { includes } from "../utils";

// TODO: get json file working in flow so this can be shared
// import deprecatedIcons from './deprecatedIcons.json';
import deprecatedIcons from "./deprecatedIcons";
import Container from "./styles";
var Icon = function Icon(_ref) {
  var name = _ref.name,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _ref$fixedWidth = _ref.fixedWidth,
    fixedWidth = _ref$fixedWidth === void 0 ? false : _ref$fixedWidth,
    ariaLabel = _ref.ariaLabel,
    color = _ref.color,
    svgProps = _ref.svgProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (includes(PartnerNames, name)) {
    // Icon's "default" size is equivalent to PartnerLogo's "small" size
    var logoSize = size === 'default' ? 'small' : size;
    var logoProps = {
      partnerName: name,
      size: logoSize,
      logoType: 'symbol',
      svgProps: svgProps
    };
    return /*#__PURE__*/React.createElement(PartnerLogo
    // ariaLabel needs to be overridable by aria-label prop in ...rest
    , _extends({
      "aria-label": ariaLabel
    }, rest, logoProps));
  }
  var iconName = deprecatedIcons[name] || name;
  var iconViewBox = iconViewBoxes[iconName];
  return /*#__PURE__*/React.createElement(Container, _extends({
    iconSize: size,
    fixedWidth: !!fixedWidth,
    key: name,
    role: "img",
    "aria-label": ariaLabel,
    "data-qa-icon": name,
    color: color
  }, rest), /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon-svg",
    viewBox: iconViewBox,
    focusable: false,
    "data-qa-icon-svg": "".concat(name, "-svg")
  }, svgProps), /*#__PURE__*/React.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#ssiconsvg-".concat(iconName)
  })));
};
var ToggleableIcon = styled(Icon).withConfig({
  displayName: "Icon__ToggleableIcon",
  componentId: "sc-7530wp-0"
})(["transition:all ", " linear;", " ", ""], function (p) {
  return p.theme.duration.fast;
}, function (p) {
  return p.active && css(["opacity:1;transform:scale(1);"]);
}, function (p) {
  return !p.active && css(["position:absolute;opacity:0;transform:scale(0);"]);
});
var IconToggle = function IconToggle(_ref2) {
  var activeName = _ref2.activeName,
    inactiveName = _ref2.inactiveName,
    isActive = _ref2.isActive,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size,
    _ref2$fixedWidth = _ref2.fixedWidth,
    fixedWidth = _ref2$fixedWidth === void 0 ? false : _ref2$fixedWidth,
    ariaLabel = _ref2.ariaLabel,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "span",
    position: "relative",
    display: "inline-flex"
  }, rest), /*#__PURE__*/React.createElement(ToggleableIcon, {
    active: isActive,
    name: activeName,
    size: size,
    fixedWidth: fixedWidth,
    "aria-label": ariaLabel,
    "aria-hidden": !isActive
  }), /*#__PURE__*/React.createElement(ToggleableIcon, {
    active: !isActive,
    name: inactiveName,
    size: size,
    fixedWidth: fixedWidth,
    "aria-label": ariaLabel,
    "aria-hidden": isActive
  }));
};
IconToggle.displayName = 'Icon.Toggle';
/**
 * **Accessibility note:** It is best practice to wrap `<Icon.Toggle />` in a button. The button must include `aria-label` and `aria-pressed` in order for a screen reader to properly communicate the icon's state. See example below.
 *
 * @example
 * const [toggleState, setToggleState] = useState(false);
 * <Button  // Wrap Icon.Toggle with Button
 *  appearance='pill'
 *  aria-label='like' // required for accessibility
 *  aria-pressed={toggleState} // required for accessibility
 *  onClick={() => setToggleState(!toggleState)}
 * >
 *  <Icon.Toggle
 *    activeName="like"
 *    inactiveName="like-outline"
 *    isActive={toggleState}
 *   />
 * </Button>
 */
Icon.Toggle = IconToggle;
export default Icon;